export { default as TakeoverPilotExperimentProvider } from 'bundles/search-common/experiments/takeoverPilot/TakeoverPilotExperimentProvider';
export { default as TakeoverCard } from 'bundles/search-common/experiments/takeoverPilot/TakeoverCard';
export type { TakeoverData } from 'bundles/search-common/experiments/takeoverPilot/TakeoverCard';

export { useTakeoverPilotHitPlacement } from 'bundles/search-common/experiments/takeoverPilot/useTakeoverPilotHitPlacement';
export type { TakeoverPilotHitPlacement } from 'bundles/search-common/experiments/takeoverPilot/useTakeoverPilotHitPlacement';
export type { TakeoverMatch } from 'bundles/search-common/experiments/takeoverPilot/getTakeoverMatchForQuery';

export { useTakeoverPilotMatchedHit } from 'bundles/search-common/experiments/takeoverPilot/useTakeoverPilotMatchedHit';
export type { TakeoverPilotMatchedHit } from 'bundles/search-common/experiments/takeoverPilot/useTakeoverPilotMatchedHit';

export {
  getInsertModeCampaign,
  buildInsertModeTakeoverData,
  buildMatchModeTakeoverData,
} from 'bundles/search-common/experiments/takeoverPilot/takeoverPilotCardProps';

export { buildTakeoverTrackingPayload } from 'bundles/search-common/experiments/takeoverPilot/takeoverPilotTracking';
export type { TakeoverTrackingArgs } from 'bundles/search-common/experiments/takeoverPilot/takeoverPilotTracking';

// So callers in a render loop (e.g. SearchCards) can memoize this once instead of passing it
// through getInsertModeCampaign's default param, which rebuilds it (and re-runs every _t() call)
// on every call.
export { getCampaignConfig } from 'bundles/search-common/experiments/takeoverPilot/takeoverPilotConfig';
